import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, CardContent, Grid } from '@material-ui/core';
import ImageWebP from './ImageWebp';
import { Footer } from './footer';
import ImageLoginPng from '../assets/img/imageLogin.png';
import LogoBmcePng from '../assets/img/logoBmce.png';

type Props = {
  children?: React.ReactNode;
};

export const LoginContainer: FC<Props> = ({ children }) => (
  <>
    <Helmet>
      <title>Login</title>
    </Helmet>
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        background: '#FFFFFF'
      }}
    >
      <Grid container direction="row">
        <Grid
          item
          md={6}
          sx={{
            background: `url(${ImageLoginPng}) no-repeat center`,
            backgroundSize: 'cover',
            display: {
              md: 'block',
              xs: 'none'
            }
          }}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
          }}
        />
        <Grid item md={6} container direction="column" alignItems="center" justifyContent="center">
          <Grid
            sx={{
              paddingLeft: '10vw',
              paddingRight: '10vw'
            }}
          >
            <ImageWebP
              childrenImage={
                <img
                  style={{ paddingBottom: '4vh', paddingLeft: '1.6vw', maxWidth: '23vw' }}
                  src={LogoBmcePng}
                  alt="Logo Bmce!"
                />
              }
            />
            <CardContent>{children}</CardContent>
            <Footer justifyContent="flex-start" />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  </>
);
